import { gql } from 'graphql-request'

import { TicketDetail } from '@/types/Ticket'

import { AttachmentQueries } from './attachments.queries'

export namespace TicketQueries {
  export const QUERY_KEYS = {
    getTickets: 'getTickets',
    getTicketDetail: 'getTicketDetail',
  }

  export function getTickets() {
    return gql`
      query Tickets($filter: TicketFilter, $sortBy: TicketSort) {
        tickets(filter: $filter, sortBy: $sortBy) {
          id
          origin
          priority
          subject
          ticketType
          ticketReason
          internalTicketStatus
          home {
            property {
              landingDirect
              isAutopilot
            }
          }
          reservation {
            professionalHousing
            standby
          }
          marketSegment {
            name
          }
          assignee {
            id
            fullName
          }
          contact {
            id
            fullName
          }
          createdAt
          lastCommentDatetime
          parentTicketId
          parentTicket {
            id
            subject
            ticketType
          }
          allowAsParent
          childTickets {
            id
            subject
            internalTicketStatus
            priority
            ticketType
            ticketReason
            createdAt
            lastCommentDatetime
            assignee {
              id
              fullName
            }
            contact {
              id
              fullName
            }
            marketSegment {
              name
            }
            home {
              property {
                landingDirect
                isAutopilot
              }
            }
            reservation {
              professionalHousing
              standby
            }
          }
        }
      }
    `
  }

  export function getTicketDetail() {
    return gql`
      query Ticket($id: Int!) {
        ticket(id: $id) {
          allowAsParent
          assignee {
            fullName
            id
          }
          attachments {
            ...AttachmentDetails
          }
          closedAt
          contact {
            fullName
            id
          }
          createdAt
          description
          externalId
          externalSource
          externalTicketStatus
          home {
            id
            searchDocument
            uninstallDate
            propertyOnlinePortal
            propertyPortalPassword
            propertyPortalUsername
            property {
              landingDirect
              isAutopilot
              directPartnerUser {
                fullName
                email
                phone
              }
            }
          }
          id
          internalTicketStatus
          marketSegment {
            id
            name
          }
          priority
          reservation {
            id
          }
          creator {
            fullName
            id
          }
          subject
          ticketReason
          ticketReasonId
          ticketStatusId
          ticketType
          ticketTypeId
          ticketHomeArea
          ticketHomeAreaId
          permissionToEnter
          supportedReactions
          parentTicketId
          parentTicket {
            id
            subject
            internalTicketStatus
            ticketType
          }
          childTickets {
            id
            subject
            internalTicketStatus
            ticketType
            priority
            createdAt
            assignee {
              fullName
            }
          }
        }
      }
      ${AttachmentQueries.ATTACHMENT_DETAILS}
    `
  }

  export interface GetTicketDetailReturn {
    tickets: TicketDetail[]
  }

  export const TIMELINE_TICKETS = gql`
    fragment TimelineTickets on Ticket {
      id
      origin
      priority
      subject
      ticketType
      ticketReason
      internalTicketStatus
      reservation {
        professionalHousing
        standby
      }
      assignee {
        fullName
      }
      contact {
        fullName
      }
      createdAt
      closedAt
      lastCommentDatetime
      parentTicketId
      parentTicket {
        id
        subject
        ticketType
      }
    }
  `

  export function searchParentTickets() {
    return gql`
      query SearchParentTickets($filter: TicketFilter, $sortBy: TicketSort) {
        tickets(filter: $filter, sortBy: $sortBy) {
          id
          subject
          ticketType
          internalTicketStatus
        }
      }
    `
  }
}
